var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "emd-card-grid__row" },
    [
      _c("div", { staticClass: "emd-card-grid__column" }, [
        _c(
          "p",
          { staticClass: "emd-text _color_subtle _type_caption eu-mb_1" },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("charge.detail.payment-method.cash.description")
                ) +
                " "
            ),
          ]
        ),
        _c("p", { staticClass: "emd-card-grid__line" }, [
          _vm._v(" " + _vm._s(_vm.lastTransaction.description || "-") + " "),
        ]),
      ]),
      _c("DetailAt", {
        attrs: { "updated-at": _vm.updatedAt, "created-at": _vm.createdAt },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }